import React from 'react';
import { Text, Container, Button} from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();

  const handleBack = () => {
    const visiUserData = localStorage.getItem('visiUserData');
    if (visiUserData) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  return (
     <Container style={{ height: '90vh', display: 'flex', flexDirection: 'column',justifyContent: 'center',alignItems: 'center',textAlign: 'center',}}>
      <Text size={100} fw={700} c="#5D707B">404</Text>
      <Text size={20} fw={500} c="#28282B" style={{ width: '290px' }}>Sorry, we couldn't find this page.</Text>
      <Button mt={12} style={{ width: '300px' }} onClick={handleBack}>
        Back to Home
      </Button>
    </Container>
  );
}

